import React from "react";
import { Users, AlertOctagon, Activity } from "lucide-react";
import RiskGauge from "./RiskGauge";

const fmt = (n) => (n ?? 0).toLocaleString("en-IN");

const Tile = ({ icon: Icon, label, value, sub, accent, testid }) => (
  <div className="panel p-3 flex flex-col gap-1 min-w-0" data-testid={testid}>
    <div className="flex items-center justify-between">
      <span className="micro-label">{label}</span>
      <Icon className="w-3.5 h-3.5 text-muted-foreground" strokeWidth={1.5} />
    </div>
    <div className={`font-mono text-2xl font-semibold tracking-tighter ${accent || ""}`}>
      {value}
    </div>
    <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
      {sub}
    </div>
  </div>
);

export const KpiStrip = ({ bootstrap, kpi, alerts }) => {
  const occ = kpi?.total_occupancy ?? bootstrap?.kpis?.total_occupancy ?? 0;
  const cap = bootstrap?.kpis?.total_capacity ?? 0;
  const pct = cap ? Math.round((occ / cap) * 100) : 0;
  const risk = kpi?.composite_risk ?? bootstrap?.kpis?.composite_risk ?? 0;
  const active = alerts.filter((a) => a.status !== "resolved").length;
  const crit = alerts.filter((a) => a.severity === "critical" && a.status !== "resolved").length;
  const ack = alerts.filter((a) => a.status === "ack").length;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 p-2 border-b border-border">
      <div className="panel p-3 flex items-center" data-testid="kpi-risk">
        <RiskGauge value={risk} />
      </div>
      <Tile
        icon={Users}
        label="Occupancy"
        value={fmt(occ)}
        sub={`${pct}% · cap ${fmt(cap)}`}
        testid="kpi-occupancy"
      />
      <Tile
        icon={AlertOctagon}
        label="Active Alerts"
        value={fmt(active)}
        sub={`${crit} critical · ${ack} ack`}
        accent={crit > 0 ? "sev-critical" : ""}
        testid="kpi-alerts"
      />
      <Tile
        icon={Activity}
        label="Gate Throughput"
        value={`${Math.round(80 + Math.random() * 30)}/min`}
        sub="aggregated across gates"
        testid="kpi-throughput"
      />
    </div>
  );
};

export default KpiStrip;
